import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import axios from 'axios';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { saveSpecimen } from '../../redux/actions';

class UploadComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showLoadingbar: false,
      uploadProgress: 0,
      fileName: '',
      fileSize: '',
      fileMbps: '',
      fileType: '',
      timeElapsed: 0,
      serverResponded: false,
      errorMsg: '',
    };
    // preserve the initial state in a new object
    this.baseState = this.state;
  }

  handleOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({ ...this.baseState, open: false });
    if (this.state.showLoadingbar) {
      this.source.cancel('Operation canceled by the user.');
    }
  };


  calcTimeLeft = () => moment.utc(((this.state.timeElapsed / this.state.uploadProgress) * (100 - this.state.uploadProgress)) * 1000).format('HH:mm:ss');

  handleUpload = (e) => {
    if (!e.target.files.length) return;
    this.source = axios.CancelToken.source();
    const t0 = performance.now();
    const file = e.target.files[0];
    this.setState({
      showLoadingbar: true,
      fileName: file.name,
      fileSize: (file.size / (10 ** 6)).toFixed(2),
      fileType: file.type,
    });

    const formData = new FormData();
    formData.append('file', file);
    const url = `${process.env.REACT_APP_CADESS_API_URL}/specimen/upload`;
    const username = `${process.env.REACT_APP_CADESS_API_USERNAME}`;
    const password = `${process.env.REACT_APP_CADESS_API_PASSWORD}`;

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
      auth: {
        username,
        password,
      },
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.total;
        const t1 = performance.now();
        this.setState({
          fileMbps: `${((progressEvent.loaded * 8) / (t1 - t0) / 1000).toFixed(2)}Mbit/s`,
          timeElapsed: (t1 - t0) / 1000,
        });
        if (totalLength > 0) {
          this.setState({
            uploadProgress: ((progressEvent.loaded * 100) / totalLength),
          });
        } else {
          this.setState({
            errorMsg: 'Could not connect to server.',
          });
        }
      },
      cancelToken: this.source.token,
    };
    axios.post(url, formData, config)
      .then((response) => {

        this.setState({
          serverResponded: true,
          cadessId: response.data.specimen_id,
          imgUrl: response.data.original_image,
          cadessImgUrl: response.data.CADESS_image,
          thumbnail: `${process.env.REACT_APP_CADESS_API_URL}/specimen/thumbnail/${response.data.specimen_id}_200_200.png`,
          specimenImage: `${process.env.REACT_APP_CADESS_API_URL}/specimen/thumbnail/${response.data.specimen_id}_1024_1024.png`,
        });
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
        } else {
          console.log(error);
        }
      });
  };

  handleSubmit = () => {
    const {
      cadessId,
      imgUrl,
      cadessImgUrl,
      thumbnail,
      specimenImage,
    } = this.state;

    const cadessData = {
      cadessId,
      imgUrl,
      cadessImgUrl,
      thumbnail,
      specimenImage,
    };

    this.props.handleImageUploaded(cadessData, this.props.specimen);

    this.setState({ ...this.baseState, open: false });
  };

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        onClick={this.handleClose}
      />,
      <FlatButton
        disabled={!this.state.serverResponded}
        label="Submit"
        style={{ visibility: this.state.serverResponded ? 'visible' : 'hidden' }}
        onClick={this.handleSubmit}
      />,
    ];

    const style = {
      fileInfoStyle: {
        fontStyle: 'italic',
        fontSize: '0.8em',
        float: 'left',
        clear: 'left',
      },
      progressbarBackgroundStyle: {
        backgroundColor: '#ededed',
        width: '100%',
        height: '30px',
        overflow: 'hidden',

      },
      progressbarStyle: {
        background: 'linear-gradient(#8080be 0%, #5e5ead 100%)',
        backgroundSize: '400% 400%',
        height: '30px',
        width: `${this.state.uploadProgress}%`,
        animation: this.state.uploadProgress >= 100 && !this.state.serverResponded ? 'gradient 0.5s ease infinite' : 'none',
      },
      progressbarTextStyle: {
        color: 'white',
        float: 'right',
        lineHeight: '30px',
        marginRight: '10px',
      },
      mbpsStyle: {
        fontSize: '0.8em',
      },
      timeLeftStyle: {
        float: 'right',
        fontSize: '0.8em',
      },
    };

    const Progressbar = () => {
      let test;
      if (this.state.uploadProgress.toFixed(0) >= 100 && !this.state.serverResponded) {
        test = (
          <p className="saving">Waiting for server<span>.</span><span>.</span><span>.</span></p>);
      } else {
        test = '';
      }

      return (
        <div>
          <span style={style.fileInfoStyle}>File name: {this.state.fileName}</span>
          <span style={style.fileInfoStyle}>File size: {this.state.fileSize}MB</span>
          <span style={style.fileInfoStyle}>File Type: {this.state.fileType}</span>
          <div style={style.progressbarBackgroundStyle}>
            <div style={style.progressbarStyle}>
              <span style={style.progressbarTextStyle}>
                {this.state.uploadProgress.toFixed(0)}%
                </span>
            </div>
          </div>
          <div>
            <span style={style.mbpsStyle}>{this.state.fileMbps}</span>
            <span style={style.timeLeftStyle}>Time left: {this.calcTimeLeft()}</span>
            <br />
          </div>
          {test}
        </div>
      )
    };

    return (
      <div>
        <Button disabled={this.props.disabled} variant="contained" color="primary" type="button" onClick={this.handleOpen} data-testid="uploadTissueImageButton">UPLOAD</Button>

        <Dialog
          contentStyle={{ height: '2000px' }}
          actions={actions}
          modal={false}
          open={this.state.open}
          autoScrollBodyContent
        >
          <h2 className="text-center">Upload a tissue image</h2>
          {this.state.showLoadingbar ? (
            <div>
              {this.state.errorMsg !== '' ?
                <span style={{ color: 'red' }}>{this.state.errorMsg}</span> : <Progressbar />
              }
            </div>
          )
            :
            (
              <div>
                <span>Select a File to Upload</span>
                <br /><br />
                <label htmlFor="fileToUpload">
                  <span className="btn--form" style={{ marginBottom: '30px', width: '142px' }}>Choose file</span>
                  <input
                    type="file"
                    name="fileToUpload"
                    className="default-file-upload"
                    id="fileToUpload"
                    onChange={this.handleUpload}
                    onClick={(e) => { e.target.value = null; }}
                  />
                </label>
              </div>
            )}
          {this.state.serverResponded
            ? (
              <div
                style={{
                  width: '100%',
                  marginTop: '20px',
                  backgroundColor: 'rgba(204, 170, 59, 0.4)',
                  overflow: 'auto',
                }}
              >
                <img src={this.state.thumbnail} alt="Specimen thumbnail" style={{ float: 'left', margin: '1em' }} />
                <div style={{ margin: '20px', float: 'left' }}>
                  Your file: <b>{this.state.fileName}</b> has been received successfully.
                    <br />
                  The size of the file is: <b>{this.state.fileSize}MB</b>
                </div>
              </div>
            ) : null}

        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = ({ _case, auth }) => {
  const { user } = auth;
  const {
    cases,
    selectedCase,
    specimens,
    tableHasChanged,
  } = _case;
  return {
    user, cases, selectedCase, specimens, tableHasChanged,
  };
};


export default connect(mapStateToProps, { saveSpecimen })(UploadComponent);

